import { render, staticRenderFns } from "./MerchantAnouncement.vue?vue&type=template&id=96bd9872&scoped=true&"
import script from "./MerchantAnouncement.vue?vue&type=script&lang=js&"
export * from "./MerchantAnouncement.vue?vue&type=script&lang=js&"
import style0 from "./MerchantAnouncement.vue?vue&type=style&index=0&id=96bd9872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bd9872",
  null
  
)

export default component.exports